import { MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { TOWNS } from "../data/content";

const slug = (t) => t.toLowerCase().replace(/[()]/g, "").replace(/\s+/g, "-");

export const Region = () => (
    <section id="region" className="py-20 lg:py-32 px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto" data-testid="region-section">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <Reveal>
                <Eyebrow num="05" label="Einsatzgebiet" />
                <h2 className="font-display font-semibold tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl leading-[1.12]">
                    Zuhause im<br />Landkreis Celle.
                </h2>
                <p className="mt-6 text-base sm:text-lg text-shade leading-relaxed max-w-lg">
                    Kurze Anfahrt, feste Termine, persönlicher Kontakt. Ob Heckenschnitt in Celle,
                    Pflasterreinigung in Winsen oder Rasenpflege in Hambühren – wir sind in der
                    gesamten Region für Sie unterwegs.
                </p>
            </Reveal>
            <Reveal delay={0.12}>
                <div className="flex flex-wrap gap-2.5">
                    {TOWNS.map((t) => (
                        <span
                            key={t}
                            data-testid={`region-chip-${slug(t)}`}
                            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white border border-hairline text-sm font-medium text-forest transition-[background-color,border-color] duration-200 hover:bg-leaf-light hover:border-leaf/30 cursor-default"
                        >
                            <MapPin size={13} className="text-leaf" strokeWidth={2.4} />
                            {t}
                        </span>
                    ))}
                    <span className="inline-flex items-center px-4 py-2 rounded-full bg-forest text-leaf-soft text-sm font-medium">
                        + gesamte Umgebung
                    </span>
                </div>
            </Reveal>
        </div>
    </section>
);
